if ($(window).width() < 768) {
	var bg = $('.js-main-banner').attr('style');
	$('.js-mobl-banner').attr('style', bg);
	$('.js-main-banner').removeAttr('style');
}